import { sendPushNotificationOnLiveCall } from './sendPushNotificationOnLiveCall';

export const pushNotificationService = {
  sendPushNotificationOnLiveCall,
};
